var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { tagRelationsApi } from '@data/rest/api';
import { useQueryClient } from '@tanstack/react-query';
import { addQueryClientArrayMember, removeQueryClientArrayMember } from '@util/query';
import toast from 'react-hot-toast';
import { useTagContext } from './tagContext';
import { TagQueryKeys } from './types';
export function useTableTagRelationsActions() {
    var queryClient = useQueryClient();
    var tagData = useTagContext().tagData;
    return {
        addTableTagRelation: function addTableTagRelation(payload) {
            return __awaiter(this, void 0, void 0, function () {
                var relations, createdRelation;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            relations = tagData.relationsByTableTagId[payload.tableTagId];
                            if (!!(relations === null || relations === void 0 ? void 0 : relations.find(function (relation) {
                                return relation.connectedTableTagId === payload.connectedTableTagId;
                            }))) return [3 /*break*/, 2];
                            return [4 /*yield*/, tagRelationsApi.create(payload)];
                        case 1:
                            createdRelation = _a.sent();
                            addQueryClientArrayMember(queryClient, TagQueryKeys.Relations, createdRelation);
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        removeTableTagRelation: function removeTableTagRelation(tableId, connectedTableId) {
            return __awaiter(this, void 0, void 0, function () {
                var relations, find;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            relations = tagData.relationsByTableTagId[tableId];
                            find = relations === null || relations === void 0 ? void 0 : relations.find(function (relation) { return relation.connectedTableTagId === connectedTableId; });
                            if (!find) return [3 /*break*/, 2];
                            return [4 /*yield*/, tagRelationsApi._delete(find.id)];
                        case 1:
                            _a.sent();
                            removeQueryClientArrayMember(queryClient, TagQueryKeys.Relations, find.id);
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        addTableRelationConnectedTagByName: function addTableRelationConnectedTagByName(relationId, tagId, connectedTagName, tableTagId) {
            return __awaiter(this, void 0, void 0, function () {
                var connectedTag, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 4, , 5]);
                            connectedTag = tagData.getTagByNameAndParent(connectedTagName, tableTagId);
                            if (!!connectedTag) return [3 /*break*/, 1];
                            throw new Error("Tag doesn't exist");
                        case 1: return [4 /*yield*/, tagRelationsApi.addConnections(relationId, {
                                connections: [
                                    {
                                        dimensionTagId: tagId,
                                        connectedDimensionTagId: connectedTag.id,
                                    },
                                ],
                            })];
                        case 2:
                            _a.sent();
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            _a.label = 3;
                        case 3: return [3 /*break*/, 5];
                        case 4:
                            err_1 = _a.sent();
                            toast.error('Error adding connected tag', err_1.message);
                            return [3 /*break*/, 5];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        addTableRelationConnectedTag: function addTableRelationConnectedTag(relationId, tagId, connectedTagId) {
            return __awaiter(this, void 0, void 0, function () {
                var err_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, tagRelationsApi.addConnections(relationId, {
                                    connections: [
                                        {
                                            dimensionTagId: tagId,
                                            connectedDimensionTagId: connectedTagId,
                                        },
                                    ],
                                })];
                        case 1:
                            _a.sent();
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            return [3 /*break*/, 3];
                        case 2:
                            err_2 = _a.sent();
                            toast.error('Error adding connected tag', err_2.message);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        addAndRemoveTableRelationConnectedTags: function setTableRelationConnectedTags(relationId, connectionsToAdd, connectionsToRemove) {
            return __awaiter(this, void 0, void 0, function () {
                var err_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            if (!(connectionsToAdd.length > 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, tagRelationsApi.addConnections(relationId, { connections: connectionsToAdd })];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!(connectionsToRemove.length > 0)) return [3 /*break*/, 4];
                            return [4 /*yield*/, tagRelationsApi.removeConnections(relationId, { connections: connectionsToRemove })];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            return [3 /*break*/, 6];
                        case 5:
                            err_3 = _a.sent();
                            toast.error('Error adding connected tags', err_3.message);
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        },
        addTableRelationConnectedTags: function addTableRelationConnectedTag(relationId, connections) {
            return __awaiter(this, void 0, void 0, function () {
                var err_4;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, tagRelationsApi.addConnections(relationId, { connections: connections })];
                        case 1:
                            _a.sent();
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            return [3 /*break*/, 3];
                        case 2:
                            err_4 = _a.sent();
                            toast.error('Error adding connected tags', err_4.message);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        removeTableRelationConnectedTag: function removeTableRelationConnectedTag(relationId, tagId, connectedTagId) {
            return __awaiter(this, void 0, void 0, function () {
                var err_5;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, tagRelationsApi.removeConnections(relationId, {
                                    connections: [
                                        {
                                            dimensionTagId: tagId,
                                            connectedDimensionTagId: connectedTagId,
                                        },
                                    ],
                                })];
                        case 1:
                            _a.sent();
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            return [3 /*break*/, 3];
                        case 2:
                            err_5 = _a.sent();
                            toast.error('Error removing connected tag', err_5.message);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
        removeTableRelationConnectedTags: function removeTableRelationConnectedTag(relationId, connections) {
            return __awaiter(this, void 0, void 0, function () {
                var err_6;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, tagRelationsApi.removeConnections(relationId, { connections: connections })];
                        case 1:
                            _a.sent();
                            queryClient.invalidateQueries(TagQueryKeys.Relations);
                            return [3 /*break*/, 3];
                        case 2:
                            err_6 = _a.sent();
                            toast.error('Error removing connected tag', err_6.message);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        },
    };
}
